import React from "react";
import "./SimplePricing.css";
import Dots from "../../../../assets/images/about-shape3.png";
import Triangle1 from "../../../../assets/images/pricingsec1tri1.png";
import Triangle2 from "../../../../assets/images/pricingsec1tri2.png";
const data = [
  { service: "Federal Tax return(1040/104NR)", price: "$30" },
  { service: "State Tax Return", price: "$34.99" },
  { service: "City & Local tax return", price: "$19.99" },
  { service: "Schedule A (Itemized Deductions)", price: "$50" },
  {
    service: "ITIN Document verification & certification process",
    price: "$150",
  },
  { service: "ITIN W7 (Only application for)", price: "$20" },
  { service: "NonResident spouse election", price: "$50" },
  { service: "Business Filing", price: "$300" },
  { service: "FATCA", price: "$45" },
];
const SimplePricing = () => {
  return (
    <div className="simple__pricing_section">
      <img src={Dots} alt="" className="simple__pricing_dots" />
      <div className="simple__pricing_tablewrap">
        <img
          src={Triangle1}
          alt=""
          className="simple__pricing_tabletriangle1"
        />
        <img
          src={Triangle2}
          alt=""
          className="simple__pricing_tabletriangle2"
        />
        <div className="simple__pricing_table">
          <div className="simple__pricing_tableheading">
            Our Simple Pricing For You
          </div>
          <div className="simple__pricing_tablecontent">
            <div className="simple__pricingtab_contentheader">
              <div className="simple__pricingtab_chleft">Service</div>
              <div className="simple__pricingtab_chright">Price</div>
            </div>
            {data.map((item, index) => (
              <div
                className="simple__pricingtab_contentitem"
                style={{
                  background:
                    index % 2 === 0
                      ? "rgba(52, 182, 188, 0.2)"
                      : "rgba(52, 182, 188, 0.02)",
                }}
              >
                <div className="simple__pricingtab_cileft">{item.service}</div>
                <div className="simple__pricingtab_ciright">{item.price}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SimplePricing;
